import { makeStyles } from 'tss-react/mui'
import FreeFreightIcon from '@src/icons/FreeFreightIcon'
import ShipsTodayIcon from '@src/icons/ShipsTodayIcon'
import { ShippingTypes } from '@src/utils/searchUtils'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles()((theme) => ({
  icon: {
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
  },
}))
interface ShippingFacetProps {
  value: string
}

const ShippingFacet: React.FC<ShippingFacetProps> = ({ value }) => {
  const { classes } = useStyles()

  const icon =
    value === ShippingTypes.SameDay ? (
      <ShipsTodayIcon color="secondary" sx={{ fontSize: 34 }} />
    ) : (
      <FreeFreightIcon color="secondary" sx={{ fontSize: 34 }} />
    )

  return (
    <>
      <FormattedMessage
        id={value.toUpperCase().replace(' ', '_')}
        defaultMessage={value}
      />
      <span className={classes.icon}>{icon}</span>
    </>
  )
}

export default ShippingFacet
